import http from "@/assets/js/common/http-common";

class OSCEDataService {
  send(data) {
    return http.post("prova/osce/send", data);
  }

  listSent() {
    return http.post("prova/osce/listSent", null);
  }

  alunoMyEvaluations() {
    return http.post("prova/aluno/osce/myEvaluations", null);
  }
}

export default new OSCEDataService();
